/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloudAccountMiniPartialUpdate
 */
export interface CloudAccountMiniPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof CloudAccountMiniPartialUpdate
     */
    provider?: CloudAccountMiniPartialUpdateProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountMiniPartialUpdate
     */
    name?: string;
}

/**
* @export
* @enum {string}
*/
export enum CloudAccountMiniPartialUpdateProviderEnum {
    Azure = 'azure',
    Aws = 'aws',
    Backblaze = 'backblaze',
    Gcloud = 'gcloud'
}

export function CloudAccountMiniPartialUpdateFromJSON(json: any): CloudAccountMiniPartialUpdate {
    return CloudAccountMiniPartialUpdateFromJSONTyped(json, false);
}

export function CloudAccountMiniPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloudAccountMiniPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CloudAccountMiniPartialUpdateToJSON(value?: CloudAccountMiniPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider': value.provider,
        'name': value.name,
    };
}


